import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  SvgIcon,
  Typography,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import useIsMobile from "../utils/hooks/useIsMobile";

const CustomDialog = ({
  open,
  onClose,
  title,
  size,
  heigth,
  fullScreen,
  children,
  isBottom,
  Actions
}) => {
  const isMobile = useIsMobile();
  const checkMobileAndBottom = isBottom && isMobile;

  return (
    <Dialog
      onClose={onClose}
      open={open}
      maxWidth={size ? size : "xs"}
      fullWidth
      fullScreen={fullScreen}
      keepMounted
      sx={{
        ...(checkMobileAndBottom && {
          position: "fixed",
          bottom: 0,
          margin: 0,
          borderRadius: "8px 8px 0 0",
          m: 0,
          ".MuiPaper-root": {
            margin: 0,
            position: "fixed",
            bottom: 0,
            borderRadius: "8px 8px 0 0",
            width: "100%",
            maxWidth: "600px",
          },
        }),
      }}
    >
      {title && (
        <DialogTitle
          sx={{
            backgroundColor: "primary.main",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography sx={{ color: "text.white", fontSize: 16 }}>
            {title}
          </Typography>
          <IconButton onClick={onClose}>
            <SvgIcon sx={{ fontSize: 18, color: "text.white" }}>
              <CloseIcon />
            </SvgIcon>
          </IconButton>
        </DialogTitle>
      )}

      <DialogContent
        sx={{ maxHeight: heigth ? heigth : 297, overflowY: "auto", p: 0 }}
      >
        {children}
      </DialogContent>
      {Actions}
    </Dialog>
  );
};

export default CustomDialog;
